import { ElMessage, ElMessageBox } from 'element-plus'
import privateCapabilities from '@cttq/private-capabilities-v3';
import type { ResponseType } from "@cttq/cttq-request";

export const loginOut = (callback: () => void) => {
  const globalState = privateCapabilities.userGlobalState()
  ElMessageBox.confirm("是否退出登录?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning"
  }).then(() => {
    // logout没有定义类型，这里只能写any
    globalState.logout().then((res: any) => {

        if (res.msgCode == "100" || res.msgCode == "4004") {
          callback()
          const baseUrl = import.meta.env[`VITE_LOGIN_URL`];
          const routerBase = import.meta.env[`VITE_ROUTERBASE`];
          const url = baseUrl + "/cvue/Login-WebPC/login?callback=" + baseUrl + routerBase;
          window.location.href = url;
        }
    }).catch((error: unknown) => {
      console.log(error, 'http');
      ElMessage({
        type: "info",
        message: `退出失败`
      });
    });

  }).catch((error: unknown) => {
    console.log(error);
    ElMessage({
      type: "info",
      message: `已取消退出`
    });
  });
}